import { render, staticRenderFns } from "./Punto_Medicion.vue?vue&type=template&id=1caea09b&"
import script from "./Punto_Medicion.vue?vue&type=script&lang=js&"
export * from "./Punto_Medicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports